import HasLabel from "./HasLabel";

export interface Permission {
    id: number;
    name: string;
    groupName: string;
    description: string;
    permissionCodeName: string;
    isDefault: boolean;
    obsolete: boolean;
}

export class Permission extends HasLabel {

    constructor(obj?: Permission) {
        super();
        this.id = 0;

        if (obj) {
            Object.assign(this, obj);
        }
    }

    toString(): string {
        if (this.name) {
            return `<div class="font-weight-normal">${this.isDefault?"⭐":""}<b>${this.groupName}</b> - ${this.name}</div>`;
        }
        return '<div class="font-weight-light">Permission</div>';
    }

    getLabel(): string {
        return this.toString();
    }

}
